import React, { useEffect } from 'react';
import { Editor } from '@tiptap/core';

import TextStyle from '@tiptap/extension-text-style';
import TextAlign from '@tiptap/extension-text-align';
import { EditorContent } from '@tiptap/react';
import Underline from '@tiptap/extension-underline';
import { Color } from '@tiptap/extension-color';
import { lowlight } from 'lowlight/lib/core';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';

import {
  CustomParagraph,
  CustomCode,
  CustomHorizontalRule,
  CustomBlockquote,
  CustomOrderedList,
  CustomBulletList,
  CustomImage,
  ImageLinkNode,
  TextTransform,
  TextDecoration,
  FontSize,
  FontWeight,
  CustomLink,
  CustomFontFamily
} from './CustomTiptapExtensions';

import StarterKit from '@tiptap/starter-kit';



// !BUG IN CSS HIGHLIGHTING!
// import css from 'highlight.js/lib/languages/css';
import js from 'highlight.js/lib/languages/javascript';
import html from 'highlight.js/lib/languages/xml';
import Iframe from './Iframe';

// lowlight.registerLanguage('css', css);
lowlight.registerLanguage('html', html);
lowlight.registerLanguage('js', js);

function setupContent(props) {

  const {
    editable,
    content,
    baseUrlTamplate
  } = props;

  return {
    editable: false,
    extensions: [
      StarterKit.configure({
        history: false,
        horizontalRule: false,
        codeBlock: false,
        blockquote: false,
        code: false,
        paragraph: false,
        heading: {
          HTMLAttributes: {
            class: 'editor-heading',
          },
          levels: [3]
        }
      }),
      Iframe,
      CustomCode,
      CustomHorizontalRule,
      TextStyle,
      Underline,
      CodeBlockLowlight.configure({
        lowlight,
      }),
      CustomLink(baseUrlTamplate).configure({
        openOnClick: true,
        protocols: ['ftp', 'mailto', 'http', 'https'],
        HTMLAttributes: {
          // Change rel to different value
          // Allow search engines to follow links(remove nofollow)
          rel: 'noopener noreferrer',
          // Remove target entirely so links open in current tab
          target: null,
        },
      }),
      CustomParagraph,
      CustomBlockquote,
      CustomBulletList,
      CustomOrderedList,
      ImageLinkNode,
      CustomFontFamily,
      FontSize,
      FontWeight,
      TextTransform,
      TextDecoration,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      CustomImage,
      Color.configure({
        types: ['textStyle'],
      })
    ],
    editorProps: {
      attributes: {
        class: "Editor"
      }
    },

    content: content
  }
}

function setupEditor(props) { 
  return new Editor(setupContent(props))
}

function TiptapRender(props) {

  const {
    content,
    renderSync
  } = props;
  
  // if (renderSync) {

    const setupEditorContent = setupEditor(props);

    useEffect(() => {
      return () => {
        setupEditorContent.destroy();
      };
    }, []);

    return (
      <EditorContent editor={setupEditorContent} />
    );  
  // }

  // const editorContent = useEditor(setupContent(props), [content]);

  // return (
  //   <EditorContent editor={editorContent} />
  // );
};

export default TiptapRender;